import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxCheckedDisabled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
			fill: "#E9EBF1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2022 7.28939C18.1162 7.19769 18.0139 7.12491 17.9012 7.07524C17.7885 7.02557 17.6676 7 17.5454 7C17.4233 7 17.3024 7.02557 17.1897 7.07524C17.077 7.12491 16.9747 7.19769 16.8887 7.28939L9.99734 14.5877L7.10205 11.5157C7.01277 11.4245 6.90737 11.3528 6.79188 11.3047C6.67638 11.2565 6.55306 11.2329 6.42894 11.2352C6.30482 11.2375 6.18234 11.2656 6.06849 11.3179C5.95464 11.3702 5.85165 11.4458 5.76541 11.5402C5.67916 11.6346 5.61134 11.7461 5.56583 11.8682C5.52032 11.9904 5.49799 12.1208 5.50014 12.2521C5.50229 12.3834 5.52886 12.5129 5.57834 12.6333C5.62783 12.7537 5.69925 12.8626 5.78853 12.9539L9.34058 16.7106C9.42657 16.8023 9.52888 16.8751 9.6416 16.9248C9.75433 16.9744 9.87523 17 9.99734 17C10.1195 17 10.2404 16.9744 10.3531 16.9248C10.4658 16.8751 10.5681 16.8023 10.6541 16.7106L18.2022 8.72752C18.2961 8.63591 18.371 8.52472 18.4223 8.40096C18.4735 8.2772 18.5 8.14356 18.5 8.00845C18.5 7.87334 18.4735 7.7397 18.4223 7.61594C18.371 7.49219 18.2961 7.381 18.2022 7.28939Z",
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 1.5H18V-1.5H6V1.5ZM22.5 6V18H25.5V6H22.5ZM18 22.5H6V25.5H18V22.5ZM1.5 18V6H-1.5V18H1.5ZM6 22.5C3.51472 22.5 1.5 20.4853 1.5 18H-1.5C-1.5 22.1421 1.85786 25.5 6 25.5V22.5ZM22.5 18C22.5 20.4853 20.4853 22.5 18 22.5V25.5C22.1421 25.5 25.5 22.1421 25.5 18H22.5ZM18 1.5C20.4853 1.5 22.5 3.51472 22.5 6H25.5C25.5 1.85786 22.1421 -1.5 18 -1.5V1.5ZM6 -1.5C1.85786 -1.5 -1.5 1.85786 -1.5 6H1.5C1.5 3.51472 3.51472 1.5 6 1.5V-1.5Z",
			fill: "#D9DEEB"
		})
	]
});
const ForwardRef = forwardRef(SvgCheckboxCheckedDisabled);
export default ForwardRef;
